<template>
    <sub-page id="m-authentication" title="实名认证" :closeBtn="true" :fullPage="true">
        <div class="page-container" v-loading="loading">

            <!-- 已验证 -->
            <div class="verified" v-if="step === -1">
                <div class="img-wrap">
                    <img src="../../assets/images/common/verified.png" alt="verified">
                </div>
                <div class="detail">
                    <h3>恭喜！您已完成安培云实名认证</h3>
                    <p>真实姓名：{{data.inputName}}</p>
                    <p>证件号码：{{data.inputIDCardNumber}}</p>
                </div>
            </div>

            <!-- 使用须知 -->
            <div class="step-accept" v-if="step === 0">
                <h3>您正在使用实名认证服务</h3>
                <div class="accept-content" v-if="disclaimer">
                    <p>{{disclaimer}}</p>
                </div>
                <el-checkbox v-model="accept" class="accept-radio">
                    勾选后，点击按钮即您同意《用户信息授权协议》并确认授权
                </el-checkbox>
                <div class="accept-btn">
                    <el-button @click="step=1" type="success" :disabled="!accept">同意授权，并继续</el-button>
                </div>
            </div>

            <!-- 开始实名认证 -->
            <div class="step-detail" v-if="[1, 2, 3].includes(step)">
                <el-steps class="step-banner" :active="step-1" finish-status="success" simple>
                    <el-step title="身份信息" icon="el-icon-edit"></el-step>
                    <el-step title="证件照片" icon="el-icon-picture"></el-step>
                    <el-step title="活体验证" icon="el-icon-video-camera"></el-step>
                </el-steps>

                <!-- 第一步 表单 -->
                <section class="step-info" v-show="step===1">
                    <info-auth
                        :initData="data"
                        @stepChange="stepChanged"
                    >
                    </info-auth>
                </section>

                <!-- 第二步 照片上传 -->
                <section class="step-image" v-show="step===2">
                    <image-auth
                        :initData="data"
                        @stepChange="stepChanged"
                    >
                    </image-auth>
                </section>

                <!-- 第三步 视频验证 -->
                <section class="step-video" v-show="step===3">
                    <video-auth
                        @stepChange="stepChanged"
                        @finishAuth="finishAuth"
                        :active="step===3"
                    >
                    </video-auth>
                </section>
            </div>
        </div>
    </sub-page>
</template>

<script>
    import SubPage from '@/components/Subpage.vue'
    import {Ticket} from '@/utils'
    import InfoAuth from './InfoAuth'
    import ImageAuth from './ImageAuth'
    import VideoAuth from './VideoAuth'

    export default {
        components: {
            SubPage,
            InfoAuth,
            ImageAuth,
            VideoAuth
        },
        data() {
            return {
                loading: true,
                accept: false,
                step: null,        //-1:已验证 0:第一次验证 1/2/3:具体的第123步
                data: null,
                disclaimer: ''
            }
        },

        /**
         *  调接口，loading，如果无数据，则为第一次，展示免责
         *  有数据 verified 展示详情，!verified 展示具体步骤
         */
        created() {
            this.$api.getRealNameDetail().then(res => {
                let data = res.package
                this.loading = false

                if (!data) {
                    this.step = 0
                    this.$api.getRealNameDisclaimer().then(rst => {
                        this.disclaimer = rst.package
                    })
                    return
                }

                this.data = data
                this.step = data.isVerified ? -1: 1;

            }).catch(e => {
                this.loading = false
            })
        },
        methods: {
            stepChanged(num) {
                this.step = this.step + num
            },

            // 完成验证
            finishAuth() {
                this.loading = true
                this.$api.getRealNameDetail().then(res => {
                    this.step = -1
                    this.data = res.package
                    this.loading = false
                })
            }
        },
    }
</script>

<style lang="scss">
    #m-authentication {

        .page-container {
            position: relative;
            height: 100%;
            font-family: Helvetica Neue, Helvetica,
            "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        }

        .verified {
            position: absolute;
            top: 35%;
            left:  50%;
            transform: translateX(-50%);
            display: flex;
            img {
                width: 140px;
            }
            .detail {
                margin-left: 50px;
                padding-top: 20px;
                h3 {
                    margin-bottom: 15px;
                    color: #333;
                    font-size: 18px;
                    font-weight: 600;
                }
                p {
                    margin-bottom: 10px;
                    color: #888;
                }
            }
        }

        .step-accept {
            width: 500px;
            margin: 0 auto;

            h3 {
                padding: 15px 0;
                font-size: 16px;
                color: #666;
            }

            .accept-content {
                padding: 15px;
                background-color: #F9F9F9;
                color: #888;

                h4 {
                    margin-bottom: 10px;
                    line-height: 1.8;
                }

                ul {
                    padding-left: 20px;
                    list-style-type: disc;

                    li {
                        margin-bottom: 10px;
                    }
                }
            }

            .accept-radio {
                margin: 30px 0;
            }

            .accept-btn {
                text-align: center;
            }
        }

        .step-detail {
            .step-banner {
                width: 60%;
                min-width: 750px;
                margin: 0 auto;
            }

            section {
                width: 500px;
                margin: 0 auto;

                .tips {
                    margin: 20px 0;
                    line-height: 1.8;
                    list-style-type: disc;
                    color: #999;
                }

                .btn-group {
                    padding: 10px 0;
                    text-align: center;
                }
            }
        }

        .el-card__header {
            padding: 5px 0;
            font-size: 16px;
            background-color: #f8f8f9;
        }

        .sub-page-header {
            display: flex;
            align-items: center;
            color: #4c4c4c;

            > span {
                flex: 1;
            }
        }

        .btn-header {
            padding: 4px 10px;
            margin-right: 20px;
        }

        .not-support {
            height: 200px;
            padding-top: 40px;
        }
    }

    .app-student-main #m-authentication {
        $top-height: 110px;
        margin-top: $top-height;
        height: calc(100% - #{$top-height});
        .box-card {
            width: 75%;
            min-width: 1200px;
            margin: 0 auto;
            @media screen and (max-width: 1280px) {
                min-width: 960px;
            }
        }
    }
</style>
